import { useMutation } from '@tanstack/react-query';

import { Query, Model } from './api';

interface PasswordRecoveryData {
  email: string;
  recaptcha_response: string | null;
}

export const usePasswordRecovery = () => {
  return useMutation({
    mutationFn: async (data: PasswordRecoveryData) => {
      const model = new Model('password_recovery', data);
      return await new Query('password_recovery')
        .setData(model.toAPI(), null)
        .run();
    },
  });
};
